import React, { useState, useMemo, useEffect, useRef } from 'react';
import { COUNTRIES_BY_REGION, getCountriesByRegion, getCountriesByRegionSimple } from '../../config/regionCountryDictionary.js';
import GroupedMultiSelect from './GroupedMultiSelect';

// import './RegionalCountryDropdown.scss';


// Recursively build full path for nested region/country/subregion
function transformCountry(region, country, parentPath = []) {
  const currentPath = [...parentPath, country.value];
  const result = {
    label: country.label,
    value: [region, ...currentPath].join('.'),
  };
  if (country.children && Array.isArray(country.children)) {
    result.children = country.children.map(child => {
      // If child is a string, look up the country by key
      if (typeof child === 'string') {
        const found = Object.values(_COUNTRIES_BY_REGION).flat().find(p => p.key === child);
        return found ? transformCountry(region, found, currentPath) : null;
      }
      // If child is an object, recurse (supports unlimited depth)
      return transformCountry(region, child, currentPath);
    }).filter(Boolean);
  }
  return result;
}

function transformCountriesForMultiSelect(countriesByRegion) {
  return Object.entries(countriesByRegion).map(([regionLabel, countries]) => ({
    value: regionLabel,
    label: regionLabel,
    isGroup: true,
    children: countries.map(country => transformCountry(regionLabel, country))
  }));
} 

const _COUNTRIES_BY_REGION = getCountriesByRegionSimple();
const countryGroups = transformCountriesForMultiSelect(_COUNTRIES_BY_REGION);
// console.log('COUNTRIES_BY_REGION:', _COUNTRIES_BY_REGION); 

// console.log('COUNTRY GROUPS:', countryGroups);

const RegionalCountryDropdown = ({ selectedValues, onChange, restrictRegions = null, restrictCountries = null, ...props }) => {

  if (restrictRegions && !Array.isArray(restrictRegions)) {
    console.warn('restrictRegions should be an array. Received:', restrictRegions);
  }

  if (restrictCountries && !Array.isArray(restrictCountries)) {
    console.warn('restrictCountries should be an array. Received:', restrictCountries);
  }

  // console.log('Filtering countries with restrictRegions:', _COUNTRIES_BY_REGION, countryGroups, restrictRegions);
  const filteredCountries = restrictRegions
    ? countryGroups.filter(group => restrictRegions.includes(group.value))
    : countryGroups;

  // console.log('restrictCountries Countries:', restrictCountries, filteredCountries);
  const finalFilteredCountries = restrictCountries
    ? filteredCountries
        .map(group => {
          const filteredChildren = group.children.filter(country => {
            const code = country.value.split('.').pop();
            return restrictCountries.includes(code);
          });
          return filteredChildren.length > 0 ? { ...group, children: filteredChildren } : null;
        })
        .filter(Boolean)
    : filteredCountries;

  // console.log('Final filtered countries:', finalFilteredCountries);
  return (
    <div>

    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Country: </label>
    <GroupedMultiSelect
      groups={finalFilteredCountries}
      selectedValues={selectedValues}
      onChange={onChange}
      {...props}
    />
    </div>
  );
};

export default RegionalCountryDropdown;